export default "__VITE_ASSET__PG_Cqnh6__"